import { Divider } from "@mui/material";
import JsxParser from "react-jsx-parser";
import Accordion from "@mui/material/Accordion";
import Typography from "@mui/material/Typography";
import color from "context/MaterialUITheme/color";
import { ItemGladly } from "typedef/ResponseGladly";
import { Fragment, useEffect, useState } from "react";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

interface Prop {
  answerId?: string;
  last?: boolean;
}

export default function CAccordionItem({ answerId, last }: Prop) {
  const [expanded, setExpanded] = useState<string | false>(false);
  const [result, setResult] = useState<ItemGladly>();

  useEffect(() => {
    (async () => {
      const response = await fetch(
        `https://nftydoor.us-1.gladly.com/api/v1/orgs/PmjDDOOhSXmRiBCSM7zEbQ/answers/${answerId}`
      );
      const value = await response.json();
      setResult(value);
    })();
  }, [answerId]);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Fragment>
      <Accordion
        sx={{
          "&.MuiPaper-root": {
            width: "100%",
            boxShadow: "none",
            position: "unset",
            justifyContent: "space-between",
          },
          "& .MuiAccordionSummary-root": {
            padding: 0,
          },
          "& .MuiAccordionDetails-root": {
            padding: 0,
          },
        }}
        expanded={expanded === `${answerId}`}
        onChange={handleChange(`${answerId}`)}
      >
        <AccordionSummary expandIcon={<ArrowDownwardIcon color="primary" />}>
          <Typography
            sx={[
              expanded === `${answerId}`
                ? { color: color.purple }
                : { color: color.black },
              { fontSize: 20 },
            ]}
          >
            {result?.name}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <JsxParser jsx={result?.bodyHtml} />
          </Typography>
        </AccordionDetails>
      </Accordion>
      {!last && <Divider light />}
    </Fragment>
  );
}
